import { Checkbox } from 'components/Checkbox';
import { Modal } from 'components/Modal';
import { useState } from 'react';
import TermsOfUseContent from 'features/TermsOfUse/TermsOfUseContent';

type AcceptPoliciesModalProps = {
  isHidden: boolean;
  onCancel?: () => void;
  onConfirm: () => void;
};

export const AcceptPoliciesModal: React.FC<AcceptPoliciesModalProps> = ({
  isHidden,
  onCancel,
  onConfirm,
}) => {
  const [isChecked, setIsChecked] = useState(false);
  return (
    <Modal
      heading="Terms of Use"
      headingAlign="left"
      confirmText="Accept"
      isBig={true}
      isHidden={isHidden}
      onConfirm={onConfirm}
      onCancel={onCancel}
      isCancelButtonHidden={false}
      isCloseIconHidden={false}
      isConfirmButtonDisabled={!isChecked}
    >
      <TermsOfUseContent headingLevel="h3" />
      <Checkbox
        label="I have read and agreed to the terms and conditions"
        labelPosition="right"
        onChange={(isChecked) => {
          setIsChecked(isChecked);
        }}
      ></Checkbox>
    </Modal>
  );
};
